export default __webpack_public_path__ + "static/media/icon-success-o.192a355c.svg";